import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 10"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M9.429 2.75a.25.25 0 0 0 .228-.35L8.836.552A1 1 0 0 0 7.941 0H5.75a.25.25 0 0 0-.25.25V2.5a.25.25 0 0 0 .25.25Zm-5.179 0a.25.25 0 0 0 .25-.25V.25A.25.25 0 0 0 4.25 0H2.059a1 1 0 0 0-.905.573L.344 2.4a.25.25 0 0 0 .018.237.25.25 0 0 0 .21.114Zm5.5 1H.25A.25.25 0 0 0 0 4v4.5A1.5 1.5 0 0 0 1.5 10h7A1.5 1.5 0 0 0 10 8.5V4a.25.25 0 0 0-.25-.25m-2 4.375H6.5a.625.625 0 0 1 0-1.25h1.25a.625.625 0 0 1 0 1.25"
    }, null, -1)
  ]));
}
const shoppingShippingBoxParcelPackage = { render };
export {
  shoppingShippingBoxParcelPackage as default,
  render
};
//# sourceMappingURL=shopping-shipping-box-parcel-package.svg.js.map
